import { Dialog, DialogContent, withStyles } from '@material-ui/core';
import React, { cloneElement, useEffect, useState } from 'react';

import styles from '../styles/specification';
import CustomDialogTitle from '../../../partials/customDialogTitle/CustomDialogTitle';
import DraggableDialog from '../../../partials/DraggableDialog';
import { translate } from '../../../i18n/I18nProvider';
import Specifications from './Specifications';
import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';
import { isDefined } from '../../../utils/isDefined';

const SpecificationDialog = ({ children, classes, order, client }) => {
  const [open, setOpen] = useState(false);
  const [accountName, setAccountName] = useState(null);

  useEffect(() => {
    const fetchAccount = async () => {
      if (open) {
        const response = await getData(
          `${URLS.QUOTE_CLIENTS}/${order.client?.id}/accounts`
        );

        if (isDefined(response)) {
          const foundAccount = response.find(
            el => el.externalReference === order.reference_id
          );
          setAccountName(foundAccount?.name || null);
        }
      }
    };

    fetchAccount();
  }, [open]);

  const onOpenDialog = () => {
    setOpen(true);
  };

  const onCloseDialog = () => {
    setOpen(false);
  };

  return (
    <>
      {cloneElement(children, { onClick: onOpenDialog })}
      <Dialog
        maxWidth="lg"
        classes={{
          paper: classes.root
        }}
        PaperComponent={DraggableDialog}
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onCloseDialog();
          }
        }}
      >
        <CustomDialogTitle onCloseClick={onCloseDialog}>
          {translate('ORDERS.SPECIFICATION')}
        </CustomDialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Specifications
            order={order}
            accountName={accountName}
            client={client}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(SpecificationDialog);
